import Header from "./Header";
import Footer from "./Footer";
import EducationalBanner from "./EducationalBanner";
import CookieConsent from "./CookieConsent";
import RewardsNudge from "./RewardsNudge";

const Layout = ({ children }) => (
  <div className="App min-h-screen flex flex-col">
    <EducationalBanner />
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <CookieConsent />
    <RewardsNudge />
  </div>
);

export default Layout;
